import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import homeBg from '../assets/home_3.jpg';
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section
      id="home"
      className="d-flex align-items-center"
      // style={{ minHeight: '100vh', paddingTop: '80px' }}
    >
      <Container>
        <Row className="align-items-center g-4 py-5">

          {/* Left Side Content */}
          <Col lg={6} className="text-center text-lg-start order-2 order-lg-1" data-aos="fade-right">
            <h6
              className="text-uppercase text-dark mb-3 fw-bold animate-fade-in"
              style={{ letterSpacing: '3px', fontSize: 'clamp(10px, 2vw, 14px)' }}
            >
              {t('hero.subtitle')}
            </h6>

            <h1
              className="display-4 fw-bold mb-4 animate-fade-in"
              style={{ fontFamily: 'var(--font-serif)', lineHeight: '1.2' }}
            >
              {t('hero.title')}
            </h1>

            <p className="lead text-dark mb-5 opacity-75 animate-fade-in" style={{ fontSize: 'clamp(16px, 2vw, 20px)' }}>
              {t('hero.description')}
            </p>

            <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-lg-start gap-3 animate-fade-in">
              <Button
                as={Link}
                to="/diamonds"
                size="lg"
                className="px-5 py-3 fw-bold text-uppercase d-flex align-items-center justify-content-center gap-2"
                style={{
                  backgroundColor: 'var(--color-accent)',
                  borderColor: 'var(--color-accent)',
                  color: 'white',
                  letterSpacing: '1px'
                }}
              >
                {t('hero.cta')} <ChevronRight size={20} />
              </Button>
            </div>
          </Col>

          {/* Right Side Image */}
          <Col lg={6} className="text-center order-1 order-lg-2" data-aos="fade-left" data-aos-delay="200">
            <div className="hero-img-container shadow-lg">
                <img
                    src={homeBg}
                    alt="Hero"
                    className="img-fluid"
                    style={{
                        width: "100%",
                        maxHeight: "70vh",
                        objectFit: "cover",
                        borderRadius: "12px"
                    }}
                />
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default Hero;